module.exports = __webpack_public_path__ + "static/img/partner26-hover.6fd5f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/partner26-hover.png
// module id = QDav
// module chunks = 0